<header class="">
  <!--Header-v1--->
  <section class="navbar_outer header_v1 menu-hide-in-mobile-less-991">
     <div class="navbar navbar-expand-lg  bsnav bsnav-sticky bsnav-sticky-slide header-shadow">
        <div class="container">
           <a class="navbar-brand" href="#"><img src="assets/image/logo-default.png" class="img-fluid" alt="img"></a>
           <button (click)="btnMobilemenu()"><span class="fa fa-bars font-30"></span></button>
           
           <div class="collapse navbar-collapse scroll-nav mobile-menu" id="myDIV">
              <ul class="navbar-nav navbar-mobile navbar_left  ml-auto" id="navbarnav">
                 <li  class="nav-item nav_item home">
                    <a [routerLinkActive]="['active-1']" class="nav-link link_hd" [routerLink]="['/home']"> <i class="fas fa-home"></i> </a>
                    
                 </li>
                 <li  class="nav-item nav_item">
                    <a [routerLinkActive]="['active']" class="nav-link link_hd" [routerLink]="['/aboutus']">About </a>
                 </li>

                 <!-- <li  class="nav-item nav_item">
                  <a [routerLinkActive]="['active']" class="nav-link link_hd" [routerLink]="['/aboutus']">Vaccination Passport </a>
                 </li> -->

                 <li class="nav-item nav_item drop_down"><a [routerLinkActive]="['active']" class="nav-link link_hd" href="javascript:void(0);">Get Permit to Travel</a>
               
                  <ul class="navbar-nav submenu dropdown-mobile">
                     <li class="nav-item drop-down-link-cus"><a class="nav-link" href="javascript:void(0)">International passengers <i class="fas fa-angle-right ml-2"></i> </a>
                        <ul class="drop-down-cus ">
                           <li class="nav-item nav_item"><a [routerLinkActive]="['active']" [routerLink]="['/inboundregistration']" class="nav-link blue-color ">Arriving Equatorial Guinea</a></li>
                           <li class="nav-item nav_item"><a [routerLinkActive]="['active']" [routerLink]="['/outboundregistration']" class="nav-link blue-color">Departing Equatorial Guinea</a></li>
                        </ul>
                     </li>
                     <li class="nav-item"><a class="nav-link" [routerLinkActive]="['active-1']" href="javascript:void(0)">Domestic Passengers</a></li>
                     <li class="nav-item"><a class="nav-link" [routerLinkActive]="['active-1']" href="javascript:void(0)">General Covid-19 Test</a></li>
                     <!--  This is hide only for demo -->
                     <li class="nav-item"><a class="nav-link" [routerLinkActive]="['active-1']" [routerLink]="['/makepayment']">Make Payment</a></li>

                     
                     <li class="nav-item"><a class="nav-link" [routerLinkActive]="['active-1']" [routerLink]="['/updaterecord']">Update Records</a></li>
                     <li class="nav-item"><a class="nav-link" [routerLinkActive]="['active-1']" [routerLink]="['/trackresult']">Track Result</a></li>
                  </ul>
                  
                  <li class="nav-item nav_item ml-3"><a [routerLinkActive]="['active']" class="nav-link link_hd" [routerLink]="['/locate-store']">Test Centers</a></li>
                 <li class="nav-item nav_item ml-2"><a  [routerLinkActive]="['active']" class="nav-link link_hd" [routerLink]="['/faq']">FAQ's</a></li>
                 <li class="nav-item nav_item ml-2"><a  [routerLinkActive]="['active']" class="nav-link link_hd" [routerLink]="['/contactus']">Contact Us</a></li>
                 <!-- <li [routerLinkActive]="['active']" class="nav-item nav_item"><a class="nav-link link_hd" [routerLink]="['/outboundregistration']">Registration</a></li> -->
           
               </ul>
              <ul class="navbar-nav navbar-mobile navbar_right">
                 <li><a class="theme_btn tp_two logo-button-website" [routerLink]="['/login']"><img src="assets/image/icon/login.png"> Login</a></li>
                 <li><a class="theme_btn tp_two logo-button-website" [routerLink]="['/vpassport']"><img src="assets/image/icon/passport.png"> Vaccination Passport</a></li>
              </ul>
              
           </div>


           
        </div>
     </div>
     <!--Header-v1-end-->
  </section>
<!-- menu used in desktop only desktop -->

<!-- menu used in mobile only start -->

<section class="menu-hide-in-desktop-greater-991" id="accordion">
   
   <div class="container pt-2 pb-2 my-mobile-menu">
      <a class="navbar-brand" href="#"><img src="assets/image/logo-default.png" class="img-fluid" alt="img"></a>
      <button class="menu-button-mobile" (click)="btnMobilemenu_2()" ><i class="fas fa-bars"></i></button>
   </div>

   <div class="mobile-menu-custom">
      <!-- <li><a [routerLink]="['/home']">Home</a></li>
      <li><a [routerLink]="['/aboutus']">About</a></li>
      <li><a href="#">Passenger <i class="fas fa-angle-down"></i></a>
            <ul>
               
               <li><a href="">Enrol <i class="fas fa-angle-down"></i></a>
                  <ul>
                     <li><a [routerLink]="['/inboundregistration']">Arriving Equatorial Guinea</a></li>
                     <li><a [routerLink]="['/outboundregistration']">Departing Equatorial Guinea</a></li>
                  </ul> 
               </li>
               <li><a href="">Make Payment</a></li>
               <li><a href="">Update Records</a></li>
               <li><a href="">Track Result</a></li>

            </ul>   
      </li>
      <li><a [routerLink]="['/locate-store']">Locate test Centers</a></li>
      <li><a [routerLink]="['/faq']">Faq's</a></li>
      <li><a [routerLink]="['/contactus']">Contact us</a></li>
      <li><a [routerLink]="['/login']">Login</a></li> -->
      

      <ul class="mobile-menu-2" id="accordion">

         <li><a id="headingOne"> <a [routerLink]="['/home']" > Home </a> </a></li>
         <li><a id="headingOne"> <a [routerLink]="['/aboutus']" > About us </a> </a></li>

         <li>
            <a href="javascript:void(0)" id="headingOne" data-toggle="collapse" data-target="#collapseOne" aria-controls="collapseOne"> 
               Get Permit to Travel <i class="fas fa-chevron-down"></i></a>
               
               <li id="collapseOne" class="collapse" data-parent="#accordion">
            
               <ul id="child1">
                  <li><a href="javascript:void(0)" data-toggle="collapse" data-target="#collapseOneA">Enrol  <i class="fas fa-chevron-down"></i></a>
                        <ul class="collapse" data-parent="#child1" id="collapseOneA">
                           <li><a [routerLink]="['/inboundregistration']"> Arriving Equatorial Guinea </a></li>
                           <li><a [routerLink]="['/outboundregistration']"> Departing Equatorial Guinea </a></li>
                        </ul>
                  </li>
                  <li><a [routerLink]="['/makepayment']" > Make Payment </a></li>
                  <li><a [routerLink]="['/updaterecord']" > Update Records </a></li>
                  <li><a [routerLink]="['/trackresult']" > Track Result </a></li>
               </ul>
           
         </li>

       <li> <a [routerLink]="['/locate-store']">Test Centers</a> </li>
       <li> <a [routerLink]="['/faq']">Faq's</a> </li>
       <li> <a [routerLink]="['/contactus']">Contact Us</a> </li>
       <li> <a [routerLink]="['/login']">Login</a> </li>
       <li> <a [routerLink]="['/vpassport']">Vaccination Passport</a> </li>
    

 </ul>



   </div>
  
   
</section>
<!-- menu used in mobile only end -->

</header>






